import { usePathname } from "@/src/navigation/hooks";
import { useEffect } from "react";

export function BodyBackground() {
  const pathname = usePathname();

  useEffect(() => {
    document.body.style.backgroundColor = pathname === "/" ? "#ffffff" : "#f9fafb";
  }, [pathname]);

  return null;
}
